export { default } from './text.component';
